import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from "react-dom";

import { getElementByQuerySelector, getActiveElement } from '@/helpers';

import {
  Backdrop,
  InputWrap,
  TextInput,
} from './styles';

// TODO: figure out when the component is used
const FloatableSectionContentTextarea = (props) => {
  const { text, visible, targetElementSelector, onChange, onFocus, onBlur, sectionAreaSize, inputOnType, selectedSection, scaleCoef } = props;
  const [localVisible, setLocalVisible] = useState(false);
  const [isStartedTyping, setStartedTyping] = useState(true);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [textareaSize, setTextareaSize] = useState({ height: 10, width: 10 });
  const inputRef = useRef(null);
  const initVisibleFnRef = useRef();
  const targetElement = getElementByQuerySelector(targetElementSelector);
  const fontSize = sectionAreaSize.fontSize;
  // will always create new instance of function with latest context. need for useEffect of 'keydown' subscriptions
  // need to use latest correct targetElementSelector value
  initVisibleFnRef.current = () => {
    // set text like this to fix wrong behavior with input cursor
    inputRef.current.value = text;
    inputRef.current.focus();
    // FIXME: wrong position for TM materials(ex. TC_US-TM-100.mat.json)
    if (targetElement) {
      const boundRect = targetElement.getBoundingClientRect();
      setPosition({
        top: (boundRect.top + (boundRect.height / 2)),
        left: (boundRect.left + (boundRect.width / 2))
      });
    }

    setLocalVisible(true);
    onFocus();
  };

  const onBackdropClick = () => {
    setLocalVisible(false);
    inputRef.current.blur();
    onBlur();
  };

  useEffect(() => {
    const onWindowKeyDown = (ev) => {
      if (inputRef.current && getActiveElement()?.nodeName !== 'INPUT' && getActiveElement()?.nodeName !== 'TEXTAREA') {
        initVisibleFnRef.current();
      }
    };

    window.addEventListener('keydown', onWindowKeyDown);
    return function removeListeners() {
      window.removeEventListener('keydown', onWindowKeyDown);
    }
  }, []);

  useEffect(() => {
    if (visible && !localVisible) {
      initVisibleFnRef.current();
    }
  }, [visible]);

  useEffect(() => {
    if (localVisible) {
      setTextareaSize({height: 0, width: 0});
      setTimeout(() => {
        setTextareaSize({
          height: inputRef.current.scrollHeight,
          width: inputRef.current.scrollWidth
        });
        setTimeout(() => {
          if (targetElement) {
            const boundRect = targetElement.getBoundingClientRect();
            setPosition({
              top: (boundRect.top + (boundRect.height / 2)),
              left: (boundRect.left + (boundRect.width / 2))
            });
          }
        }, 0);
      }, 0);
    }
    else {
      setTextareaSize({height: 10, width: 10});
    }
  }, [localVisible, selectedSection.text]);

  const _onChange = (e) => {
    if(isStartedTyping) {
      inputOnType(e.target.value)
      setStartedTyping(false);
    };

    setTextareaSize({
      height: e.target.scrollHeight,
      width: e.target.scrollWidth
    });
    onChange(e.target.value);
  };

  // TODO: refactoring: exclude portals to another component for better performance??
  return ReactDOM.createPortal(
    <Backdrop onClick={onBackdropClick} $visible={localVisible} >
      <InputWrap $position={position}>
        <TextInput
          ref={inputRef}
          id={'textarea-textinput'}
          style={{
            height: selectedSection.height * scaleCoef,
            width: selectedSection.width * scaleCoef,
            maxHeight: targetElement?.height || textareaSize.height,
            maxWidth: targetElement?.width || textareaSize.width,
            textAlign: 'center',
            overflowWrap: 'break-word',
            fontFamily: (selectedSection.font),
            fontStyle: (selectedSection.isItalic? 'italic' : ''),
            textDecoration: (selectedSection.isUnderline? 'underline' : ''),
            fontSize,
            lineHeight: sectionAreaSize.lineHeight,
            fontWeight: (selectedSection.isBold? 'bold' : 'normal'),
            color: (selectedSection.fontColor),
          }}
          onFocus={(e) => e.target.select()}
          onChange={_onChange}
          onClick={e => e.stopPropagation() && false}
          onBlur={() => setStartedTyping(true)}
        />
      </InputWrap>
    </Backdrop>,
    getElementByQuerySelector('#floatable-section-content-textarea-portal')
  );
};

export default React.memo(FloatableSectionContentTextarea);
